import { Box, CircularProgress } from "@mui/material"

export default function CircularProgressBox(props){
    return (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: '60vh' }}>
          <CircularProgress />
        </Box>
    )
}